import { Box, Container } from "@material-ui/core";
import React, { useState } from "react";
import "./UserQuotes.css";
import { Document, Page, pdfjs } from "react-pdf/dist/esm/entry.webpack5";
import { ToastContainer, toast } from "react-toastify";
import useFetch from "../../../../../hooks/useFetch";
import axios from "axios";
import { useParams } from "react-router-dom";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const ViewQuotes = () => {
  const [activeColor, setActiveColor] = useState("Accept");
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const { data: pdfData } = useFetch(
    `https://abc-backend.onrender.com/api/pdfquote`
  );
  const { id } = useParams();
  const { data } = useFetch(
    `https://abc-backend.onrender.com/api/quotes/${id}`
  );
  console.log(data);
  const PD = process.env.REACT_APP_PUBLIC_FOLDER_PDF;
  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
    setPageNumber(1);
  }
  const changePage = (offset) => {
    setPageNumber((prevPageNumber) => prevPageNumber + offset);
  };
  const changePageBack = () => {
    changePage(-1);
  };
  const changePageNext = () => {
    changePage(+1);
  };
  const notify = () => {
    toast.success("Successfully Added !", {
      position: toast.POSITION.TOP_CENTER,
    });
  };
  const getPdfData = pdfData.filter((item) => item.quoteId === data._id);
  const handleAccept = async (e, id) => {
    e.preventDefault();
    try {
      data.InProgress = false;
      data.status = true;
      console.log(data);
      await axios.put(
        `https://abc-backend.onrender.com/api/quotes/${id}`,
        data
      );
      notify();
    } catch (error) {
      console.log(error);
    }
  };
  const handleReject = async (e, id) => {
    e.preventDefault();
    try {
      data.reject = true;
      data.InProgress = false;
      await axios.put(
        `https://abc-backend.onrender.com/api/quotes/${id}`,
        data
      );
      notify();
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <div>
      <div>
        <Container>
          {/* <Box className="view_quotes_card_main">
            <Grid container spacing={2}>
              <Grid item xs={12} lg={4} md={4}>
                <Box className="view_quotes_card">
                  <Box>
                    <Typography variant="h6">Quote No: QT22101801 </Typography>
                  </Box>
                  <Box>
                    <Typography variant="h6">Dated: Oct. 18, 2022</Typography>
                  </Box>
                  <Box>
                    <Typography variant="h6"> Ref: RFQ708040</Typography>
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12} lg={4} md={4}>
                {" "}
                <Box className="view_quotes_card">
                  <Box>
                    <Typography variant="h6">John Doe</Typography>
                  </Box>
                  <Box>
                    <Typography variant="h6">Operation Manager</Typography>
                  </Box>
                  <Box>
                    <Typography variant="h6">ABC LLC</Typography>
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12} lg={4} md={4}>
                {" "}
                <Box className="view_quotes_card">
                  <Box>
                    <Typography variant="h6">Address</Typography>
                  </Box>
                  <Box>
                    <Typography variant="h6"> Email</Typography>
                  </Box>
                  <Box>
                    <Typography variant="h6">Contact</Typography>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Box> */}
          {/* <Container>
            <Box className="user_quote_text">
              <Typography variant="h6">Dear Mr. John Doe</Typography>
              <Typography variant="h6">
                Subject: Transportation of 8000 LTRS X4 Multi compartment tanker
                for lube oil from Dubai - Saudi
              </Typography>
              <Typography variant="h6">
                Thank you very much for showing interest and having trust on our
                services. Understanding your requirements, we are pleased to
                offer our best possible prices for the following
              </Typography>
            </Box>
          </Container> */}
          {/* <Box className="user_quote_heading">
            <Container>
              <Grid container spacing={2}>
                <Grid item xs={12} lg={1} md={1}>
                  <Typography variant="h6">S.No</Typography>
                </Grid>
                <Grid item xs={12} lg={5} md={5}>
                  <Typography variant="h6">Description</Typography>
                </Grid>
                <Grid item xs={12} lg={2} md={2}>
                  <Typography variant="h6">Rate</Typography>
                </Grid>
                <Grid item xs={12} lg={4} md={4}>
                  <Typography variant="h6">Remarks</Typography>
                </Grid>
              </Grid>
            </Container>
          </Box>
          <Box className="user_quote_content">
            <Container>
              <Grid container spacing={2}>
                <Grid item xs={12} lg={1} md={1}>
                  <Typography variant="h6">1</Typography>
                </Grid>
                <Grid item xs={12} lg={5} md={5}>
                  <Typography variant="h6">
                    Transportation (Dubai to Saudi)
                  </Typography>
                </Grid>
                <Grid item xs={12} lg={2} md={2}>
                  <Typography variant="h6">AED 10,000</Typography>
                </Grid>
                <Grid item xs={12} lg={4} md={4}></Grid>
              </Grid>
            </Container>
          </Box>
          <Box className="user_quote_content">
            <Container>
              <Grid container spacing={2}>
                <Grid item xs={12} lg={1} md={1}>
                  <Typography variant="h6">1</Typography>
                </Grid>
                <Grid item xs={12} lg={5} md={5}>
                  <Typography variant="h6">
                    Transportation (Dubai to Saudi)
                  </Typography>
                </Grid>
                <Grid item xs={12} lg={2} md={2}>
                  <Typography variant="h6">AED 10,000</Typography>
                </Grid>
                <Grid item xs={12} lg={4} md={4}></Grid>
              </Grid>
            </Container>
          </Box>
          <Box className="user_quote_content">
            <Container>
              <Grid container spacing={2}>
                <Grid item xs={12} lg={1} md={1}>
                  <Typography variant="h6">1</Typography>
                </Grid>
                <Grid item xs={12} lg={5} md={5}>
                  <Typography variant="h6">
                    Transportation (Dubai to Saudi)
                  </Typography>
                </Grid>
                <Grid item xs={12} lg={2} md={2}>
                  <Typography variant="h6">AED 10,000</Typography>
                </Grid>
                <Grid item xs={12} lg={4} md={4}></Grid>
              </Grid>
            </Container>
          </Box>
          <Box className="user_quote_content">
            <Container>
              <Grid container spacing={2}>
                <Grid item xs={12} lg={1} md={1}>
                  <Typography variant="h6">1</Typography>
                </Grid>
                <Grid item xs={12} lg={5} md={5}>
                  <Typography variant="h6">
                    Transportation (Dubai to Saudi)
                  </Typography>
                </Grid>
                <Grid item xs={12} lg={2} md={2}>
                  <Typography variant="h6">AED 10,000</Typography>
                </Grid>
                <Grid item xs={12} lg={4} md={4}></Grid>
              </Grid>
            </Container>
          </Box>
          <Box className="user_quote_content">
            <Container>
              <Grid container spacing={2}>
                <Grid item xs={12} lg={12} md={12}>
                  <Typography variant="h5">Terms and Conditions</Typography>
                </Grid>
              </Grid>
            </Container>
          </Box> */}

          {getPdfData.map((item) => (
            <>
              <div className="view_quotes_pdf">
                <Document
                  file={PD + item.pdf}
                  onLoadSuccess={onDocumentLoadSuccess}
                  key={item._id}
                >
                  <Page pageNumber={pageNumber} className="pdf_container" />
                </Document>
                <div className="pdf_btn">
                  <p>
                    Page {pageNumber} of {numPages}
                  </p>
                  {pageNumber > 1 && (
                    <button onClick={changePageBack}>Previous Page</button>
                  )}
                  {pageNumber < numPages && (
                    <button onClick={changePageNext}>Previous Page</button>
                  )}
                </div>
              </div>
              <div className="view_quote_btn">
                <Box onClick={(e) => handleAccept(e, item?.quoteId)}>
                  <button
                    onClick={() => setActiveColor("Accept")}
                    className={`quote_btn ${
                      activeColor === "Accept"
                        ? "quote_btn_active"
                        : "quote_btn"
                    }`}
                  >
                    Accept
                  </button>
                </Box>
                <Box onClick={(e) => handleReject(e, item?.quoteId)}>
                  <button
                    onClick={() => setActiveColor("Rejects")}
                    className={`quote_btn ${
                      activeColor === "Rejects" ? "quote_btn_active" : ""
                    }`}
                  >
                    Rejects
                  </button>
                </Box>
                <Box>
                  <button
                    onClick={() => setActiveColor("Request for change")}
                    className={`quote_btn ${
                      activeColor === "Request for change"
                        ? "quote_btn_active"
                        : ""
                    }`}
                  >
                    Request for change
                  </button>
                </Box>
              </div>
            </>
          ))}
        </Container>
      </div>
      <ToastContainer />
    </div>
  );
};

export default ViewQuotes;
